(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-groupee"]) return;
  try {
    

// Accordéon
document.querySelectorAll('.collection-group__title').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.collection-group');
    const isOpen = group.classList.contains('is-open');
    group.classList.toggle('is-open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  });
});

// Injection du sélecteur de quantité sur chaque ligne produit
document.querySelectorAll('.collection-groupee-wrapper [data-type="add-to-cart-form"]').forEach(form => {

  const submitBtn = form.querySelector('[type="submit"]');
  if (!submitBtn) return;

  const row = form.closest('.cg-product-row');
  const salesMultiple = row ? parseInt(row.dataset.salesMultiple) || 1 : 1;
  const multipleRequired = row ? row.dataset.multipleRequired === 'true' : false;

  const minQty = multipleRequired ? salesMultiple : 1;
  const stepQty = multipleRequired ? salesMultiple : 1;

  const qtyWrapper = document.createElement('div');
  qtyWrapper.className = 'cg-qty-wrapper';
  qtyWrapper.innerHTML = `
    <button type="button" class="cg-qty-btn cg-qty-minus" aria-label="Diminuer la quantité">−</button>
    <input type="number" name="quantity" value="${minQty}" min="${minQty}" step="${stepQty}" class="cg-qty-input" aria-label="Quantité" />
    <button type="button" class="cg-qty-btn cg-qty-plus" aria-label="Augmenter la quantité">+</button>
  `;

  submitBtn.parentNode.insertBefore(qtyWrapper, submitBtn);

  qtyWrapper.querySelector('.cg-qty-minus').addEventListener('click', () => {
    const input = qtyWrapper.querySelector('.cg-qty-input');
    const next = parseInt(input.value) - stepQty;
    if (next >= minQty) input.value = next;
  });

  qtyWrapper.querySelector('.cg-qty-plus').addEventListener('click', () => {
    const input = qtyWrapper.querySelector('.cg-qty-input');
    input.value = parseInt(input.value) + stepQty;
  });

  qtyWrapper.querySelector('.cg-qty-input').addEventListener('change', (e) => {
    let val = parseInt(e.target.value) || minQty;
    if (val < minQty) val = minQty;
    if (multipleRequired) val = Math.round(val / stepQty) * stepQty;
    e.target.value = val;
  });
});

// Ouverture du drawer panier sans redirection
document.querySelectorAll('.collection-groupee-wrapper [data-type="add-to-cart-form"]').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const submitBtn = form.querySelector('[type="submit"]');
    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    submitBtn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Erreur ajout panier');

      const parsedState = await response.json();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      }

    } catch (err) {
      console.error('Erreur ajout panier:', err);
    } finally {
      submitBtn.disabled = false;
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class AccountDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.header__account-trigger');
      this.content = this.querySelector('.header__account-content');
      this.overlay = this.querySelector('[data-account-overlay]');
      this.isOpen = false;
    }

    connectedCallback() {
      if (!this.trigger || !this.content) return;

      this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
      this.overlay?.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', this.handleEscape.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleEscape.bind(this));
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }

    handleOutsideClick(event) {
      if (!this.isOpen) return;
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    handleTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }

    handleEscape(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.content.setAttribute('aria-hidden', 'false');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('account-dropdown', AccountDropdown);

  class DrawerAccountDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.menu-drawer__account-trigger');
      this.content = this.querySelector('.menu-drawer__account-content');
      this.isOpen = false;
    }

    connectedCallback() {
      if (!this.trigger || !this.content) return;

      this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
      this.content.addEventListener('click', this.handleContentClick.bind(this));
      document.addEventListener('keydown', this.handleEscape.bind(this));
    }

    handleContentClick(event) {
      // Empêcher la propagation pour ne pas fermer le drawer parent
      event.stopPropagation();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleEscape.bind(this));
    }

    handleTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }

    handleEscape(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.content.setAttribute('aria-hidden', 'false');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('drawer-account-dropdown', DrawerAccountDropdown);

  class MegaMenuWrapper extends HTMLElement {
    constructor() {
      super();
      this.megamenuContent = this.querySelector('.mega-menu__content');
      this.menuItem = this.querySelector('.header__menu-item');
      this.isOpen = false;
    }

    connectedCallback() {
      if (!this.megamenuContent || !this.menuItem) return;

      this.menuItem.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      document.addEventListener('keydown', this.handleEscape.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
      document.removeEventListener('keydown', this.handleEscape.bind(this));
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      // Fermer tous les autres megamenus ouverts
      document.querySelectorAll('.mega-menu-wrapper.is-open').forEach((wrapper) => {
        if (wrapper !== this) {
          wrapper.classList.remove('is-open');
        }
      });

      this.toggle();
    }

    handleOutsideClick(event) {
      if (!this.isOpen) return;

      // Un clic sur le wrapper lui-même correspond au backdrop (pseudo-élément ::before),
      // car le trigger et le contenu sont des éléments enfants. On ferme donc le menu.
      const isClickOnBackdrop = event.target === this;
      const isClickInside = this.contains(event.target);
      if (!isClickInside || isClickOnBackdrop) {
        this.close();
      }
    }

    handleEscape(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
      }
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.menuItem.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.menuItem.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('mega-menu-wrapper', MegaMenuWrapper);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class ArticleTableOfContents extends HTMLElement {
    constructor() {
      super();
      this.tocItems = [];
      this.currentIndex = 0;
      this.observer = null;
      this.visibilityObserver = null;
      this.isInitialized = false;
      this.desktopList = null;
      this.mobileList = null;
      this.mobileCurrent = null;
      this.mobileDetails = null;
      this.content = null;
    }

    connectedCallback() {
      this.initialize();
      this.setupVisibilityObserver();
    }

    /**
     * Configure l'observateur de visibilité pour le composant
     */
    setupVisibilityObserver() {
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isInitialized) {
              this.initializeToc();
              this.visibilityObserver.unobserve(this);
            }
          });
        },
        {
          rootMargin: '50px 0px',
          threshold: 0.1,
        }
      );

      this.visibilityObserver.observe(this);
    }

    /**
     * Initialise le TOC une fois que le composant est visible
     */
    initializeToc() {
      if (!this.shouldCreateToc()) return;

      this.isInitialized = true;
      this.generateTocItems();
      this.setupIntersectionObserver();
      this.bindEvents();
    }

    initialize() {
      this.content = this.closest('article')?.querySelector('.main-article');
      this.desktopList = this.querySelector('.article-toc__list');
      this.mobileList = this.querySelector('.article-toc__mobile-list');
      this.mobileCurrent = this.querySelector('.article-toc__mobile-current');
      this.mobileDetails = this.querySelector('.article-toc__mobile');
    }

    shouldCreateToc() {
      if (!this.content || !this.desktopList || !this.mobileList) return false;

      const headings = this.content.querySelectorAll('h2');
      if (headings.length === 0) {
        this.style.display = 'none';
        return false;
      }

      return true;
    }

    collectHeadings() {
      const headings = this.content.querySelectorAll('h2');

      headings.forEach((heading, index) => {
        const id = heading.id || `toc-${index}`;
        if (!heading.id) {
          heading.id = id;
        }

        this.tocItems.push({
          id,
          text: heading.textContent.trim(),
          element: heading,
        });
      });
    }

    generateTocItems() {
      this.collectHeadings();
      if (this.tocItems.length === 0) return;

      this.desktopList.innerHTML = this.tocItems
        .map(
          (item, index) => `
      <li class="article-toc__item">
        <a href="#${item.id}"
           class="article-toc__link"
           data-index="${index}">
          ${item.text}
        </a>
      </li>
    `
        )
        .join('');

      this.mobileList.innerHTML = this.tocItems
        .map(
          (item, index) => `
      <li class="article-toc__mobile-item">
        <a href="#${item.id}"
           class="article-toc__mobile-link"
           data-index="${index}">
          ${item.text}
        </a>
      </li>
    `
        )
        .join('');

      if (this.mobileCurrent && this.tocItems.length > 0) {
        this.mobileCurrent.textContent = this.tocItems[0].text;
      }

      this.hideLoadingStates();
      this.setInitialActiveState();
    }

    hideLoadingStates() {
      const desktopLoading = this.querySelector('.article-toc__loading');
      const mobileLoading = this.querySelector('.article-toc__mobile-loading');

      if (desktopLoading) {
        desktopLoading.style.display = 'none';
      }

      if (mobileLoading) {
        mobileLoading.style.display = 'none';
      }

      if (this.desktopList) {
        this.desktopList.style.display = 'flex';
      }

      if (this.mobileList) {
        this.mobileList.style.display = 'flex';
      }
    }

    setInitialActiveState() {
      if (this.tocItems.length > 0) {
        this.currentIndex = 0;
        this.updateDesktopActive(0);

        if (this.mobileCurrent) {
          this.mobileCurrent.textContent = this.tocItems[0].text;
          const firstMobileLink = this.mobileList.querySelector('.article-toc__mobile-item');
          if (firstMobileLink) {
            firstMobileLink.classList.add('article-toc__mobile-item--active');
            firstMobileLink.querySelector('.article-toc__mobile-link').setAttribute('aria-current', 'true');
          }
        }
      }
    }

    setupIntersectionObserver() {
      if (!window.IntersectionObserver || this.tocItems.length === 0) return;

      const options = {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = this.tocItems.findIndex((item) => item.element === entry.target);
            if (index !== -1) {
              this.updateActiveSection(index);
            }
          }
        });
      }, options);

      this.tocItems.forEach((item) => {
        this.observer.observe(item.element);
      });
    }

    updateActiveSection(index) {
      if (index === this.currentIndex) return;

      this.currentIndex = index;
      const currentItem = this.tocItems[index];

      this.updateDesktopActive(index);
      this.updateMobileActive(currentItem.text, index);
    }

    updateDesktopActive(activeIndex) {
      const links = this.desktopList.querySelectorAll('.article-toc__link');

      links.forEach((link, index) => {
        if (index === activeIndex) {
          link.classList.add('article-toc__link--active');
          link.setAttribute('aria-current', 'true');
        } else {
          link.classList.remove('article-toc__link--active');
          link.removeAttribute('aria-current');
        }
      });
    }

    async updateMobileActive(newText, index) {
      if (!this.mobileCurrent || this.mobileCurrent.textContent === newText) return;

      this.mobileCurrent.style.opacity = '0';

      await new Promise((resolve) => setTimeout(resolve, 150));

      this.mobileCurrent.textContent = newText;

      this.mobileCurrent.style.opacity = '1';

      this.mobileList
        .querySelector('.article-toc__mobile-item--active')
        ?.classList.remove('article-toc__mobile-item--active');

      const newActiveLink = this.mobileList.querySelectorAll(`.article-toc__mobile-item`)[index];
      if (newActiveLink) {
        newActiveLink.classList.add('article-toc__mobile-item--active');
        newActiveLink.querySelector('.article-toc__mobile-link').setAttribute('aria-current', 'true');
      }
    }

    bindEvents() {
      const headerHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '100'
      );

      this.desktopList.addEventListener('click', (event) => this.handleLinkClick(event, headerHeight));
      this.mobileList.addEventListener('click', (event) => this.handleMobileLinkClick(event, headerHeight));

      if (this.mobileDetails) {
        this.mobileDetails.addEventListener('toggle', () => {
          if (this.mobileDetails.open) {
            setTimeout(() => {
              if (this.mobileDetails.open) {
                this.mobileDetails.open = false;
              }
            }, 5000);
          }
        });
      }
    }

    handleLinkClick(event, headerHeight) {
      const link = event.target.closest('.article-toc__link');
      if (!link) return;

      event.preventDefault();
      if (!this.isSamePageLink(link)) return;

      const targetElement = document.querySelector(link.hash);
      if (!targetElement) return;

      this.scrollToElement(targetElement, headerHeight);
    }

    handleMobileLinkClick(event, headerHeight) {
      const link = event.target.closest('.article-toc__mobile-link');
      if (!link) return;

      event.preventDefault();
      if (!this.isSamePageLink(link)) return;

      const targetElement = document.querySelector(link.hash);
      if (!targetElement) return;

      this.scrollToElement(targetElement, headerHeight);

      if (this.mobileDetails) {
        this.mobileDetails.open = false;
      }
    }

    isSamePageLink(link) {
      return (
        location.hostname === link.hostname && link.pathname.replace(/^\//, '') === location.pathname.replace(/^\//, '')
      );
    }

    scrollToElement(element, headerHeight) {
      const rect = element.getBoundingClientRect();
      const offsetTop = rect.top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
    }
  }

  customElements.define('article-table-of-contents', ArticleTableOfContents);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('filter-accordion')) {
    customElements.define(
      'filter-accordion',
      class FilterAccordion extends HTMLElement {
        constructor() {
          super();
          this.currentCategory = '';
          this.currentSort = 'new-old';
          this.currentTags = [];
        }

        connectedCallback() {
          this.details = this.querySelectorAll('details.filter-accordion__item');
          this.desktopAccordion = this.querySelector('.filter-accordion-desktop');
          this.filterOptions = this.closest('section').querySelectorAll('[data-filter]');
          this.modal = this.closest('section').querySelector('details-modal');
          this.applybutton = this.modal.querySelector('button[data-apply]');
          this.clearbutton = this.modal.querySelector('button[data-clear]');
          this.modalCloseButton = this.modal.querySelector('.filter-accordion-mobile__modal-close');
          this.blogGrid = this.closest('section').querySelector('#results-grid');
          this.activeFiltersContainer = this.closest('section').querySelector('[data-filters-active]');
          this.isMobile = window.innerWidth < 768;

          this.categoryButtons = this.querySelectorAll('[data-filter-category]');
          this.desktopTagFilters = this.closest('section').querySelector('.blog-tag-filters');
          this.desktopSortDropdown = this.querySelector('.blog-sort-dropdown');
          this.mobileSortOptions = this.querySelectorAll('input[data-sort-value]');

          this.baseUrl = this.dataset.blogBaseUrl || this.dataset.blogUrl;
          this.currentCategory = this.dataset.currentCategory || '';
          this.currentSort = this.dataset.currentSort || 'new-old';

          this.initializeFilters();
          this.setupListeners();
          this.setupActiveFiltersListeners();
          this.setupPaginationListeners();
          this.updateCategoryFilterCounts();

          if (this.modalCloseButton) {
            this.modalCloseButton.addEventListener('click', this.closeModal.bind(this));
          }

          window.addEventListener('resize', this.isMobileCheck.bind(this));
        }

        /**
         * @description Initialise les filtres depuis l'URL et l'état DOM
         */
        initializeFilters() {
          if (this.desktopAccordion) {
            const selectedOptions = this.desktopAccordion.querySelectorAll('[data-filter].active');
            selectedOptions.forEach((option) => {
              const value = option.dataset.value;
              if (value && !this.currentTags.includes(value)) {
                this.currentTags.push(value);
              }
            });

            if (this.modal) {
              this.currentTags.forEach((value) => {
                const mobileOption = this.modal.querySelector(`[data-filter][data-value="${value}"]`);
                if (mobileOption && !mobileOption.classList.contains('active')) {
                  mobileOption.classList.add('active');
                }
              });
            }
          }

          this.updateCategoryActiveState();
          //this.updateSortActiveState();
        }

        /**
         * @description Vérifie si on est en mode mobile et reconfigure les listeners
         */
        isMobileCheck() {
          this.isMobile = window.innerWidth < 768;
          this.setupListeners();
        }

        /**
         * @description Configure les listeners de pagination AJAX
         */
        setupPaginationListeners() {
          const paginationLinks = this.closest('section').querySelectorAll('.pagination-wrapper a[href]');
          paginationLinks.forEach((link) => {
            const boundHandler = this.handlePaginationClick.bind(this, link);
            link._paginationHandler = boundHandler;
            link.addEventListener('click', boundHandler);
          });
        }

        /**
         * @description Gère le clic sur un lien de pagination
         * @param {HTMLElement} link - Lien de pagination cliqué
         * @param {Event} event - Événement click
         */
        async handlePaginationClick(link, event) {
          event.preventDefault();

          const url = link.href;
          if (!url) return;

          this.blogGrid.parentElement.classList.add('loading');

          try {
            const response = await fetch(url);
            const responseText = await response.text();
            window.history.replaceState({}, '', url);
            this.renderHTML(responseText);
          } catch (error) {
            console.error('Error fetching pagination URL:', error);
            this.renderNoResults(error);
          } finally {
            this.blogGrid.parentElement.classList.remove('loading');
          }
        }

        /**
         * @description Supprime tous les listeners existants
         */
        removeListeners() {
          this.filterOptions.forEach((option) => {
            const boundHandler = option._boundHandler;
            if (boundHandler) {
              option.removeEventListener('click', boundHandler);
              delete option._boundHandler;
            }
          });

          if (this.details) {
            this.details.forEach((detail) => {
              if (detail._toggleHandler) {
                detail.removeEventListener('toggle', detail._toggleHandler);
                delete detail._toggleHandler;
              }
              if (detail._clickHandler) {
                detail.removeEventListener('click', detail._clickHandler);
                delete detail._clickHandler;
              }
            });
          }

          if (this._documentClickHandler) {
            document.removeEventListener('click', this._documentClickHandler);
            delete this._documentClickHandler;
          }

          if (this.applybutton && this.applybutton._clickHandler) {
            this.applybutton.removeEventListener('click', this.applybutton._clickHandler);
            delete this.applybutton._clickHandler;
          }
          if (this.clearbutton && this.clearbutton._clickHandler) {
            this.clearbutton.removeEventListener('click', this.clearbutton._clickHandler);
            delete this.clearbutton._clickHandler;
          }

          if (this._boundModalClonedListener) {
            document.removeEventListener('modal:cloned', this._boundModalClonedListener);
            delete this._boundModalClonedListener;
          }

          this.categoryButtons.forEach((button) => {
            if (button._categoryHandler) {
              button.removeEventListener('click', button._categoryHandler);
              delete button._categoryHandler;
            }
          });

          if (this.desktopSortDropdown) {
            const sortOptions = this.desktopSortDropdown.querySelectorAll('[data-sort-value]');
            sortOptions.forEach((option) => {
              if (option._sortHandler) {
                option.removeEventListener('click', option._sortHandler);
                delete option._sortHandler;
              }
            });
          }

          this.mobileSortOptions.forEach((option) => {
            if (option._mobileSortHandler) {
              option.removeEventListener('change', option._mobileSortHandler);
              delete option._mobileSortHandler;
            }
          });

          // Supprimer les listeners de pagination
          const paginationLinks = document.querySelectorAll('.pagination a[href]');
          paginationLinks.forEach((link) => {
            if (link._paginationHandler) {
              link.removeEventListener('click', link._paginationHandler);
              delete link._paginationHandler;
            }
          });
        }

        /**
         * @description Configure tous les listeners selon le mode (mobile/desktop)
         */
        setupListeners() {
          this.removeListeners();

          this.filterOptions.forEach((option) => {
            const boundHandler = this.handleTagClick.bind(this, option);
            option._boundHandler = boundHandler;
            option.addEventListener('click', boundHandler);
          });

          this.categoryButtons.forEach((button) => {
            const categoryHandler = this.handleCategoryClick.bind(this, button);
            button._categoryHandler = categoryHandler;
            button.addEventListener('click', categoryHandler);
          });

          if (this.desktopSortDropdown) {
            const sortOptions = this.desktopSortDropdown.querySelectorAll('[data-sort-value]');
            sortOptions.forEach((option) => {
              const sortHandler = this.handleSortClick.bind(this, option);
              option._sortHandler = sortHandler;
              option.addEventListener('click', sortHandler);
            });
          }

          this.mobileSortOptions.forEach((option) => {
            const mobileSortHandler = this.handleMobileSortChange.bind(this, option);
            option._mobileSortHandler = mobileSortHandler;
            option.addEventListener('change', mobileSortHandler);
          });

          if (!this.isMobile) {
            this.details.forEach((detail) => {
              const toggleHandler = () => {
                detail.setAttribute('aria-expanded', detail.hasAttribute('open') ? 'true' : 'false');
              };

              detail._toggleHandler = toggleHandler;
              detail.addEventListener('toggle', toggleHandler);

              const clickHandler = () => {
                if (!detail.hasAttribute('open')) {
                  this.details.forEach((d) => {
                    if (d !== detail) {
                      d.removeAttribute('open');
                    }
                  });
                }
              };
              detail._clickHandler = clickHandler;
              detail.addEventListener('click', clickHandler);
            });

            const documentClickHandler = (event) => {
              if (!event.target.closest('filter-accordion')) {
                this.details.forEach((detail) => detail.removeAttribute('open'));
              }
            };
            this._documentClickHandler = documentClickHandler;
            document.addEventListener('click', documentClickHandler);
          } else {
            this._boundModalClonedListener = this.modalClonedListener.bind(this);
            document.addEventListener('modal:cloned', this._boundModalClonedListener);
          }
        }

        /**
         * @description Gère le clic sur une catégorie
         * @param {HTMLElement} button - Bouton de catégorie cliqué
         */
        handleCategoryClick(button) {
          const categoryValue = button.dataset.categoryValue || '';

          this.categoryButtons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          this.currentCategory = categoryValue;
          this.currentTags = [];

          if (this.isMobile) {
            this.syncMobileCategoryState();
            this.updateMobileTagsList();
            this.fetchFilteredUrl();
          } else {
            this.updateTagFiltersList();
            this.applyFiltersInstantly();
          }
        }

        /**
         * @description Gère le clic sur un tag
         * @param {HTMLElement} option - Élément tag cliqué
         */
        handleTagClick(option) {
          const tagValue = option.dataset.value;

          if (this.isMobile) {
            option.classList.toggle('active');

            // Mettre à jour currentTags directement sans syncTagStates
            if (option.classList.contains('active')) {
              if (!this.currentTags.includes(tagValue)) {
                this.currentTags.push(tagValue);
              }
            } else {
              this.currentTags = this.currentTags.filter((value) => value !== tagValue);
            }
          } else {
            this.showLoadingState();

            // Vérifier si le tag est actuellement actif (classe active du Liquid)
            const isCurrentlyActive = option.classList.contains('active') || option.classList.contains('active');

            if (isCurrentlyActive) {
              // Supprimer le tag des currentTags AVANT le fetch
              this.currentTags = this.currentTags.filter((value) => value !== tagValue);
              option.classList.remove('active');
            } else {
              // Ajouter le tag aux currentTags
              if (!this.currentTags.includes(tagValue)) {
                this.currentTags.push(tagValue);
              }
              option.classList.add('active');
            }

            this.updateTagCheckboxes();
            this.closeTagDropdown();
            this.applyFiltersInstantly();
          }

          this.updateCategoryFilterCounts();
        }

        /**
         * @description Gère le clic sur une option de tri desktop
         * @param {HTMLElement} option - Option de tri cliquée
         */
        handleSortClick(option) {
          if (this.isMobile) return;

          const sortValue = option.dataset.sortValue;
          this.currentSort = sortValue;

          //this.updateSortActiveState();
          this.applyFiltersInstantly();
        }

        /**
         * @description Gère le changement d'option de tri mobile
         * @param {HTMLElement} option - Input radio changé
         */
        handleMobileSortChange(option) {
          if (!this.isMobile) return;

          this.currentSort = option.dataset.sortValue;
        }

        /**
         * @description Synchronise l'état des tags entre desktop et mobile
         * @param {string} tagValue - Valeur du tag
         * @param {boolean} isSelected - État sélectionné
         */
        syncTagStates(tagValue, isSelected) {
          const desktopTag = this.desktopTagFilters?.querySelector(`[data-value="${tagValue}"]`);
          const mobileTag = this.modal?.querySelector(`[data-value="${tagValue}"]`);

          if (desktopTag) {
            isSelected ? desktopTag.classList.add('active') : desktopTag.classList.remove('active');
          }
          if (mobileTag) {
            isSelected ? mobileTag.classList.add('active') : mobileTag.classList.remove('active');
          }

          if (isSelected) {
            if (!this.currentTags.includes(tagValue)) {
              this.currentTags.push(tagValue);
            }
          } else {
            this.currentTags = this.currentTags.filter((value) => value !== tagValue);
          }
        }

        /**
         * @description Met à jour les checkboxes des tags
         */
        updateTagCheckboxes() {
          const tagElements = document.querySelectorAll('.blog-tag-filters__tag[data-filter]');
          tagElements.forEach((tag) => {
            const checkbox = tag.querySelector('.blog-tag-filters__checkbox');
            if (checkbox) {
              const isActive = this.currentTags.includes(tag.dataset.value);
              checkbox.style.display = isActive ? 'inline' : 'none';
            }
          });
        }

        /**
         * @description Met à jour l'état actif des catégories
         */
        updateCategoryActiveState() {
          this.categoryButtons.forEach((button) => {
            const categoryValue = button.dataset.categoryValue || '';
            if (categoryValue === this.currentCategory) {
              button.classList.add('active');
            } else {
              button.classList.remove('active');
            }
          });
        }

        /**
         * @description Met à jour l'état actif du tri
         */
        updateSortActiveState() {
          if (this.desktopSortDropdown) {
            const sortOptions = this.desktopSortDropdown.querySelectorAll('[data-sort-value]');
            sortOptions.forEach((option) => {
              if (option.dataset.sortValue === this.currentSort) {
                option.classList.add('active');
              } else {
                option.classList.remove('active');
              }
            });
          }

          this.mobileSortOptions.forEach((option) => {
            option.checked = option.dataset.sortValue === this.currentSort;
          });
        }

        /**
         * @description Ferme le dropdown des tags desktop
         */
        closeTagDropdown() {
          if (this.desktopTagFilters) {
            this.desktopTagFilters.removeAttribute('open');
          }
        }

        /**
         * @description Affiche l'état de chargement
         */
        showLoadingState() {
          this.querySelectorAll('.filter-accordion__content').forEach((loading) => {
            loading.classList.add('loading');
          });

          this.querySelectorAll('.loading-overlay').forEach((loading) => {
            loading.classList.remove('hidden');
          });
        }

        /**
         * @description Applique les filtres instantanément (desktop)
         */
        applyFiltersInstantly() {
          if (this.isMobile) return;
          this.fetchFilteredUrl();
        }

        /**
         * @description Met à jour la liste des tags selon la catégorie
         */
        async updateTagFiltersList() {
          if (!this.desktopTagFilters) return;

          try {
            const url = this.buildFilterUrl();
            const response = await fetch(url);
            const responseText = await response.text();

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newTagFilters = html.querySelector('.blog-tag-filters');

            if (newTagFilters) {
              this.desktopTagFilters.innerHTML = newTagFilters.innerHTML;
              this.reattachTagListeners();
            }
          } catch (error) {
            this.renderNoResults(error);
          }
        }

        /**
         * @description Réattache les listeners après mise à jour AJAX
         */
        reattachTagListeners() {
          const newTagElements = this.desktopTagFilters.querySelectorAll('[data-filter]');
          newTagElements.forEach((option) => {
            const boundHandler = this.handleTagClick.bind(this, option);
            option.addEventListener('click', boundHandler);
          });
        }

        /**
         * @description Met à jour la liste des tags mobile selon la catégorie
         */
        async updateMobileTagsList() {
          // Mettre à jour le modal original ET le modal cloné
          const modals = [this.modal, this.modalClone].filter(Boolean);

          if (modals.length === 0) return;

          try {
            const url = this.buildFilterUrl();
            const response = await fetch(url);
            const responseText = await response.text();

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newMobileTagsOptions = html.querySelector('.filter-accordion-mobile__tags-options');

            if (newMobileTagsOptions) {
              modals.forEach((modal) => {
                const existingMobileTagsOptions = modal.querySelector('.filter-accordion-mobile__tags-options');
                if (existingMobileTagsOptions) {
                  existingMobileTagsOptions.innerHTML = newMobileTagsOptions.innerHTML;

                  // Réattacher les listeners sur les nouveaux tags mobiles
                  const newMobileTags = existingMobileTagsOptions.querySelectorAll('[data-filter]');
                  newMobileTags.forEach((option) => {
                    const boundHandler = this.handleTagClick.bind(this, option);
                    option.addEventListener('click', boundHandler);

                    // Synchroniser l'état avec currentTags
                    const value = option.dataset.value;
                    if (value && this.currentTags.includes(value)) {
                      option.classList.add('active');
                    } else {
                      option.classList.remove('active');
                    }
                  });
                }
              });
            }
          } catch (error) {
            console.error('Error updating mobile tags list:', error);
          }
        }

        /**
         * @description Convertit une chaîne en format handle Shopify
         * @param {string} str - Chaîne à handleizer
         * @returns {string} Chaîne handleizée
         */
        handleize(str) {
          return str
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        /**
         * @description Construit l'URL de filtrage avec catégorie, tags et tri
         * @returns {string} URL construite
         */
        buildFilterUrl() {
          let url = this.baseUrl;

          if (this.currentCategory || this.currentTags.length > 0) {
            url += '/tagged/';

            const taggedParts = [];

            if (this.currentCategory) {
              taggedParts.push(this.handleize(this.currentCategory.replace("'", '')));
            }

            if (this.currentTags.length > 0) {
              const handleizedTags = this.currentTags.map((tag) => this.handleize(tag));
              taggedParts.push(...handleizedTags);
            }

            url += taggedParts.join('+');
          }

          if (this.currentSort && this.currentSort !== 'new-old') {
            url += `?sort_by=${this.currentSort}`;
          }

          return url;
        }

        /**
         * @description Gestionnaire du modal cloné (mobile)
         * @param {CustomEvent} event - Événement de clonage du modal
         */
        modalClonedListener(event) {
          this.modalClone = event.detail.modalClone;

          this.modalClone.querySelectorAll('[data-filter]').forEach((option) => {
            option.addEventListener('click', this.handleTagClick.bind(this, option));

            const value = option.dataset.value;
            if (value && this.currentTags.includes(value)) {
              option.classList.add('active');
            } else {
              option.classList.remove('active');
            }
          });

          this.modalClone.querySelectorAll('[data-filter-category]').forEach((button) => {
            const categoryHandler = this.handleCategoryClick.bind(this, button);
            button.addEventListener('click', categoryHandler);

            const categoryValue = button.dataset.categoryValue || '';
            if (categoryValue === this.currentCategory) {
              button.classList.add('active');
            } else {
              button.classList.remove('active');
            }
          });

          this.modalClone.querySelectorAll('input[data-sort-value]').forEach((option) => {
            option.addEventListener('change', this.handleMobileSortChange.bind(this, option));
            option.checked = option.dataset.sortValue === this.currentSort;
          });

          const applyButton = this.modalClone.querySelector('button[data-apply]');

          if (applyButton) {
            applyButton.addEventListener('click', this.applyMobileFilters.bind(this));
          }

          const clearButton = this.modalClone.querySelector('button[data-clear]');
          if (clearButton) {
            clearButton.addEventListener('click', this.clearFilters.bind(this));
          }

          const modalCloseButton = this.modalClone.querySelector('.filter-accordion-mobile__modal-close');
          if (modalCloseButton) {
            modalCloseButton.addEventListener('click', this.closeModal.bind(this));
          }

          this.updateCategoryFilterCounts();
        }

        /**
         * @description Applique les filtres mobiles (différé)
         */
        applyMobileFilters() {
          if (!this.isMobile) return;
          if (!this.modalClone) return;

          const selectedMobileTags = this.modalClone.querySelectorAll('[data-filter].selected');
          const activeMobileTags = this.modalClone.querySelectorAll('[data-filter].active');

          const tagsToUse = selectedMobileTags.length > 0 ? selectedMobileTags : activeMobileTags;
          this.currentTags = Array.from(tagsToUse).map((tag) => tag.dataset.value);

          const selectedMobileCategory = this.modalClone.querySelector('[data-filter-category].active');
          if (selectedMobileCategory) {
            this.currentCategory = selectedMobileCategory.dataset.categoryValue || '';
          }

          this.modal.close();

          this.syncAllTagStates();
          this.showMobileLoadingState();
          this.fetchFilteredUrl();
        }

        /**
         * @description Synchronise tous les états de tags après application mobile
         */
        syncAllTagStates() {
          this.filterOptions.forEach((option) => {
            const tagValue = option.dataset.value;
            if (this.currentTags.includes(tagValue)) {
              option.classList.add('active');
            } else {
              option.classList.remove('active');
            }
          });

          this.updateTagCheckboxes();
        }

        /**
         * @description Synchronise l'état de la catégorie mobile
         */
        syncMobileCategoryState() {
          if (this.modalClone) {
            const mobileCategoryButtons = this.modalClone.querySelectorAll('[data-filter-category]');
            mobileCategoryButtons.forEach((button) => {
              const categoryValue = button.dataset.categoryValue || '';
              if (categoryValue === this.currentCategory) {
                button.classList.add('active');
              } else {
                button.classList.remove('active');
              }
            });
          }

          this.updateCategoryFilterCounts();
        }

        /**
         * @description Affiche l'état de chargement mobile
         */
        showMobileLoadingState() {
          if (this.modalClone) {
            const applyButton = this.modalClone.querySelector('button[data-apply]');
            if (applyButton) {
              applyButton.classList.add('loading');
              applyButton.querySelector('.loading__spinner')?.classList.remove('hidden');
            }
          }
        }

        /**
         * @description Configure les listeners pour les filtres actifs
         */
        setupActiveFiltersListeners() {
          if (this.activeFiltersContainer) {
            const removeButtons = this.activeFiltersContainer.querySelectorAll('[data-filter-remove]');
            removeButtons.forEach((button) => {
              const filterItem = button.closest('.active-filters__item');

              if (filterItem) {
                button.addEventListener('click', () => this.removeActiveFilter(filterItem.dataset.value));
              }
            });

            const clearAllButton = this.activeFiltersContainer.querySelector('[data-clear-all-filters]');
            if (clearAllButton) {
              clearAllButton.addEventListener('click', () => this.clearAllFilters());
            }
          }
        }

        /**
         * @description Supprime un filtre actif
         * @param {string} value - Valeur du filtre à supprimer
         */
        removeActiveFilter(value) {
          this.currentTags = this.currentTags.filter((tag) => tag !== value);

          this.filterOptions.forEach((option) => {
            if (option.dataset.value === value) {
              option.classList.remove('active');
            }
          });

          this.updateTagCheckboxes();
          this.updateCategoryFilterCounts();
          this.fetchFilteredUrl();
        }

        /**
         * @description Met à jour le comptage des filtres par catégorie
         */
        updateCategoryFilterCounts() {
          const categoryCounts = {};
          const desktopAccordion = document.querySelector('.filter-accordion-desktop');
          if (!desktopAccordion) return;

          const accordionItems = desktopAccordion.querySelectorAll('.filter-accordion__item');

          accordionItems.forEach((item) => {
            const categorySpan = item.querySelector('[data-filter-category]');
            if (!categorySpan) return;

            const categoryName = categorySpan.textContent.trim();
            const filterOptions = item.querySelectorAll('[data-filter]');

            let activeCount = 0;
            filterOptions.forEach((option) => {
              if (option.classList.contains('active')) {
                activeCount++;
              }
            });

            categoryCounts[categoryName] = activeCount;
          });

          document.querySelectorAll('[data-filter-category]').forEach((categorySpan) => {
            const categoryName = categorySpan.textContent.trim();
            const count = categoryCounts[categoryName] || 0;
            const countElement = categorySpan.nextElementSibling;

            if (countElement && countElement.hasAttribute('data-count')) {
              countElement.textContent = count > 0 ? `(${count})` : '';
              countElement.style.display = count > 0 ? '' : 'none';
            }
          });

          const totalFilterCountElement = document.querySelector('[data-total-filter-count]');
          if (totalFilterCountElement) {
            totalFilterCountElement.textContent = `(${this.currentTags.length})`;
            totalFilterCountElement.style.display = this.currentTags.length > 0 ? '' : 'none';
          }
        }

        /**
         * @description Efface tous les filtres
         */
        clearFilters() {
          this.currentTags = [];
          this.currentCategory = '';
          this.currentSort = 'new-old';

          this.filterOptions.forEach((option) => {
            option.classList.remove('active');
          });

          this.updateCategoryActiveState();
          //this.updateSortActiveState();
          this.updateTagCheckboxes();
          this.updateCategoryFilterCounts();
          this.fetchFilteredUrl();
        }

        /**
         * @description Efface tous les filtres sauf la catégorie courante
         */
        clearAllFilters() {
          const tagCategories = this.dataset.tagCategories ? this.dataset.tagCategories.split(',') : [];

          if (this.currentCategory) {
            this.currentTags = this.currentTags.filter((tag) => tagCategories.includes(tag));
          } else {
            this.currentTags = [];
          }

          this.filterOptions.forEach((option) => {
            const tagValue = option.dataset.value;
            const isCategory = tagCategories.includes(tagValue);

            if (!isCategory || !this.currentCategory) {
              option.classList.remove('active');
            }
          });

          this.updateTagCheckboxes();
          this.updateCategoryFilterCounts();
          this.fetchFilteredUrl();
        }

        /**
         * @description Ferme le modal mobile
         */
        closeModal() {
          this.modal.close();
        }

        /**
         * @description Récupère et applique les résultats filtrés
         */
        async fetchFilteredUrl() {
          const filteredUrl = this.buildFilterUrl();
          window.history.replaceState({}, '', filteredUrl);

          this.blogGrid.parentElement.classList.add('loading');

          try {
            const response = await fetch(filteredUrl);
            const responseText = await response.text();
            this.renderHTML(responseText);
          } catch (error) {
            console.error('Error fetching filtered URL:', error);
            this.renderNoResults(error);
          } finally {
            this.blogGrid.parentElement.classList.remove('loading');

            if (!this.isMobile) {
              this.details.forEach((detail) => {
                detail.removeAttribute('open');
              });
            } else if (this.modalClone) {
              const applyButton = this.modalClone.querySelector('button[type="submit"][data-apply]');
              applyButton?.classList.remove('loading');
              applyButton?.querySelector('.loading__spinner')?.classList.add('hidden');
            }
          }
        }

        /**
         * @description Affiche un message d'erreur
         * @param {Error} error - Erreur survenue
         */
        renderNoResults(error) {
          this.blogGrid.innerHTML = `<p>${this.dataset.noResults}</p>`;
          this.blogGrid.classList.add('no-results');

          // Ouvrir les filtres desktop en cas de no-results
          if (!this.isMobile && this.desktopTagFilters) {
            this.desktopTagFilters.setAttribute('open', '');
          }

          this.scrollToResults();
        }

        /**
         * @description Rendu du HTML après fetch AJAX
         * @param {string} responseText - Réponse HTML
         */
        renderHTML(responseText) {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const results = html.querySelector('#results-grid');
          const activeFilters = html.querySelector('[data-filters-active]');
          const loadMoreWrapper = html.querySelector('.load-more-button-wrapper');
          const existingLoadMoreWrapper = document.querySelector('.main-blog .load-more-button-wrapper');
          const paginationWrapper = html.querySelector('.pagination-wrapper');
          const existingPaginationWrapper = document.querySelector('.main-blog .pagination-wrapper');
          const newTagFilters = html.querySelector('.blog-tag-filters');

          if (results) {
            this.blogGrid.innerHTML = results.innerHTML;

            const hasNoResults = results.classList.contains('no-results');

            if (hasNoResults) {
              this.blogGrid.classList.add('no-results');
              // Ouvrir les filtres desktop en cas de no-results
              if (!this.isMobile && this.desktopTagFilters) {
                this.desktopTagFilters.setAttribute('open', '');
              }
            } else {
              this.blogGrid.classList.remove('no-results');
            }

            if (loadMoreWrapper) {
              if (existingLoadMoreWrapper) {
                existingLoadMoreWrapper.innerHTML = loadMoreWrapper.innerHTML;
              } else {
                document.querySelector('.main-blog').appendChild(loadMoreWrapper.cloneNode(true));
              }
            } else if (existingLoadMoreWrapper) {
              existingLoadMoreWrapper.remove();
            }

            if (paginationWrapper) {
              if (existingPaginationWrapper) {
                existingPaginationWrapper.innerHTML = paginationWrapper.innerHTML;
              } else {
                document.querySelector('.main-blog').appendChild(paginationWrapper.cloneNode(true));
              }
            } else if (existingPaginationWrapper) {
              existingPaginationWrapper.remove();
            }
          }

          if (activeFilters && this.activeFiltersContainer) {
            this.activeFiltersContainer.innerHTML = activeFilters.innerHTML;
            this.setupActiveFiltersListeners();
          }

          if (newTagFilters && this.desktopTagFilters) {
            this.desktopTagFilters.innerHTML = newTagFilters.innerHTML;
            this.reattachTagListeners();
            this.updateTagCheckboxes();
          }

          // Mettre à jour le count des tags actifs
          const newTagsCountElement = html.querySelector('[data-current-tags-count]');
          if (newTagsCountElement) {
            const existingTagsCountElements = document.querySelectorAll('[data-current-tags-count]');
            existingTagsCountElements.forEach((element) => {
              element.textContent = newTagsCountElement.textContent;
              element.setAttribute(
                'data-current-tags-count',
                newTagsCountElement.getAttribute('data-current-tags-count')
              );

              if (newTagsCountElement.classList.contains('hidden')) {
                element.classList.add('hidden');
              } else {
                element.classList.remove('hidden');
              }
            });
          }

          this.updateCategoryActiveState();
          this.updateSortActiveState();
          this.setupPaginationListeners();

          if (this.isMobile) {
            this.closeModal();
          } else {
            this.scrollToResults();
          }

          // Scroll vers les résultats après fetch
          const resultsGrid = document.querySelector('#results-grid');
          if (resultsGrid) {
            resultsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        /**
         * @description Fait défiler vers les résultats
         */
        scrollToResults() {
          this.querySelectorAll('.filter-accordion__content').forEach((loading) => {
            loading.classList.remove('loading');
          });
          this.querySelectorAll('.loading-overlay').forEach((loading) => {
            loading.classList.add('hidden');
          });

          const resultsTop = this.blogGrid.closest('section').getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: resultsTop, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.searchQueryString === '') {
          return;
        }

        this.fetchUrl();
      }

      async fetchUrl() {
        const response = await fetch(
          `${this.dataset.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`
        );

        const div = document.createElement('div');
        div.innerHTML = await response.text();
        const recentlyViewedProductsElement = div.querySelector('recently-viewed-products');

        if (recentlyViewedProductsElement && recentlyViewedProductsElement.hasChildNodes()) {
          this.innerHTML = recentlyViewedProductsElement.innerHTML;
        }
      }

      get searchQueryString() {
        const items = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');

        if (
          this.hasAttribute('exclude-product-id') &&
          items.includes(parseInt(this.getAttribute('exclude-product-id')))
        ) {
          items.splice(items.indexOf(parseInt(this.getAttribute('exclude-product-id'))), 1);
        }

        return items
          .map((item) => 'id:' + item)
          .slice(0, this.productsCount)
          .join(' OR ');
      }

      get sectionId() {
        return this.getAttribute('section-id');
      }

      get productsCount() {
        return this.getAttribute('products-count') || 4;
      }
    }
  );

  } catch(e) { console.error(e); }
})();
})();
